'use strict';

angular
    .module('substoreApp')
    .config(configRoutes);

function configRoutes($routeProvider) {
    $routeProvider.when('/catalogue', { templateUrl: 'partials/catalogue.html', controller: 'catalogueController', resolve: { dialogData: resolver(getCatalogueData) } });
    $routeProvider.when('/myproducts', { templateUrl: 'partials/myproducts.html', controller: 'myproductsController', resolve: { dialogData: resolver(getMyproductsData) } });
    $routeProvider.when('/myproducts/:subscriptionTemplateId', { templateUrl: 'partials/myproducts.html', controller: 'myproductsController', resolve: { dialogData: resolver(getMyproductsData) } });
    $routeProvider.when('/productdetails/:subscriptionTemplateId', { templateUrl: 'partials/productdetails.html', controller: 'productdetailsController', resolve: { dialogData: resolver(getProductdetailsData) } });
    $routeProvider.when('/orderselection/:subscriptionTemplateId', { templateUrl: 'partials/orderselection.html', controller: 'orderselectionController', resolve: { dialogData: resolver(getOrderselectionData) } });
    $routeProvider.when('/ordersummary/:subscriptionTemplateId/:orderCallId/:mode?', { templateUrl: 'partials/ordersummary.html', controller: 'ordersummaryController', resolve: { dialogData: resolver(getOrdersummaryData) } });
    $routeProvider.when('/orderconfirmation/:subscriptionTemplateId', { templateUrl: 'partials/orderconfirmation.html', controller: 'orderconfirmationController', resolve: { dialogData: resolver(getOrderconfirmationData) } });
    $routeProvider.when('/orderconfirmation/:subscriptionTemplateId/:mode', { templateUrl: 'partials/orderconfirmation.html', controller: 'orderconfirmationController', resolve: { dialogData: resolver(getOrderconfirmationData) } });
    $routeProvider.when('/reservationconfirmation/:subscriptionTemplateId', { templateUrl: 'partials/reservationconfirmation.html', controller: 'reservationconfirmationController', resolve: { dialogData: resolver(getReservationconfirmationData) } });
    $routeProvider.when('/productchangeselection/:subscriptionTemplateId/:uniqueSubscriptionId', { templateUrl: 'partials/productchangeselection.html', controller: 'productchangeselectionController', resolve: { dialogData: resolver(getProductchangeselectionData) } });
    $routeProvider.when('/productchangesummary/:subscriptionTemplateId/:uniqueSubscriptionId/:newSubscriptionTemplateId', { templateUrl: 'partials/productchangesummary.html', controller: 'productchangesummaryController', resolve: { dialogData: resolver(getProductchangesummaryData) } });
    $routeProvider.when('/productchangeconfirmation/:subscriptionTemplateId/:uniqueSubscriptionId', { templateUrl: 'partials/productchangeconfirmation.html', controller: 'productchangeconfirmationController', resolve: { dialogData: resolver(getProductchangeconfirmationData) } });
    $routeProvider.when('/orderadministrationselection/:subscriptionTemplateId/:uniqueSubscriptionId', { templateUrl: 'partials/orderadministrationselection.html', controller: 'orderadministrationselectionController', resolve: { dialogData: resolver(getOrderadministrationselectionData) } });
    $routeProvider.when('/orderadministrationselection/:subscriptionTemplateId/:uniqueSubscriptionId/:requestedParameterValue', { templateUrl: 'partials/orderadministrationselection.html', controller: 'orderadministrationselectionController', resolve: { dialogData: resolver(getOrderadministrationselectionData) } });
    $routeProvider.when('/orderadministrationsummary/:subscriptionTemplateId/:uniqueSubscriptionId/:requestedParameterValue', { templateUrl: 'partials/orderadministrationsummary.html', controller: 'orderadministrationsummaryController', resolve: { dialogData: resolver(getOrderadministrationsummaryData) } });
    $routeProvider.when('/orderadministrationconfirmation/:subscriptionTemplateId/:uniqueSubscriptionId', { templateUrl: 'partials/orderadministrationconfirmation.html', controller: 'orderadministrationconfirmationController', resolve: { dialogData: resolver(getOrderadministrationconfirmationData) } });
    $routeProvider.when('/processing', { templateUrl: 'partials/processing.html' });
    $routeProvider.when('/error', { templateUrl: 'partials/error.html' });
    $routeProvider.when('/error/:code', { templateUrl: 'partials/error.html' });
    $routeProvider.when('/logout', { templateUrl: 'partials/logout.html' });
    $routeProvider.when('/logout/:redirectTo', { templateUrl: 'partials/logout.html' });
    $routeProvider.when('/', { resolve: { load: forwardDefault }});
    $routeProvider.otherwise({ redirectTo: '/error/INVALID_URL' });

    // redirect to either catalogue or myproducts, if we have a session and are allowed to

    function forwardDefault($location, $route, sessionData) {
        sessionData.promise.then(function() {
            // only handle if we do not have a fault. If we have a fault, this has been handled below in run()
            if (!sessionData.hasFault()) {
                // we might have been run into a race condition:
                // if "/" did come with a cryptoticket having routing arguments (e.g. like '&page=...')
                // then we were already routed away on behalf of initial ui service invocation. So
                // we do check location again and if changed then we silently ignore this case
                if ($location.path() !== "/")
                    return;

                // the parameter 'action' is set if we're coming from a 3rd party authentication page
                var action = $route.current.params.action;
                if (sessionData.dialogStaticData.showCatalogue && (!action || action == 'catalogue')) {
                    $location.path("/catalogue");
                } else if (sessionData.dialogStaticData.showMyProducts && (!action || action == 'myproducts')) {
                    $location.path("/myproducts");
                } else if (action == 'ordersummary') {
                    // parameter 'action' has been given (we're coming from a 3rd party authentication page); go directly to ordersummary page
                    $location.url('/ordersummary/' + sessionData.transient.subscriptionTemplateId + '/' + sessionData.transient.orderCallId);
                } else {
                    throw { code: "ACCESS_DENIED" };
                }
            }
        });
        return sessionData.promise;
    }

    // dependency resolving functions

    function getCatalogueData(sessionData, uiservice) {
        return uiservice.catalogueDialogData({
            sessionId: sessionData.sessionId
        });
    }

    function getMyproductsData(sessionData, uiservice) {
        return uiservice.myProductsOverviewDialogData({
            sessionId: sessionData.sessionId,
            msisdn: sessionData.dialogStaticData.msisdn
        });
    }

    function getProductdetailsData(sessionData, uiservice, $route) {
        return uiservice.productDetailsDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: $route.current.params.subscriptionTemplateId
        });
    }

    function getOrderselectionData(sessionData, uiservice, $route) {
        var subscriptionTemplateId = sessionData.transient.subscriptionTemplateId = $route.current.params.subscriptionTemplateId;
        sessionData.transient.orderCallId = $route.current.params.orderCallId;

        return uiservice.orderSelectionDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: subscriptionTemplateId
        });
    }

    function getOrdersummaryData(sessionData, uiservice, $route) {
        var subscriptionTemplateId = sessionData.transient.subscriptionTemplateId = $route.current.params.subscriptionTemplateId;
        var orderCallId = sessionData.transient.orderCallId = $route.current.params.orderCallId;
        var optin = $route.current.params.mode === "optin" ? true : undefined;

        return uiservice.orderSummaryDialogData({
            sessionId: sessionData.sessionId,
            orderCallId: orderCallId,
            subscriptionTemplateId: subscriptionTemplateId,
            optin: optin
        });
    }

    function getOrderconfirmationData(sessionData, uiservice, $route) {
        var subscriptionTemplateId = sessionData.transient.subscriptionTemplateId = $route.current.params.subscriptionTemplateId;
        var mode = { optin: ($route.current.params.mode === "optin") ? true : undefined };
        var confirmationInProgress = $route.current.params.mode === 'inProgress';

        return uiservice.orderConfirmationDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: subscriptionTemplateId,
            optin: mode.optin,
            confirmationInProgress: confirmationInProgress
        });
    }

    function getReservationconfirmationData(sessionData, uiservice, $route) {
        return uiservice.reservationConfirmationDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: $route.current.params.subscriptionTemplateId
        });
    }

    function getProductchangeselectionData(sessionData, uiservice, $route) {
        return uiservice.productChangeSelectionDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: $route.current.params.subscriptionTemplateId,
            uniqueSubscriptionId: $route.current.params.uniqueSubscriptionId
        });
    }

    function getProductchangesummaryData(sessionData, uiservice, $route) {
        return uiservice.productChangeSummaryDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: $route.current.params.subscriptionTemplateId,
            uniqueSubscriptionId: $route.current.params.uniqueSubscriptionId,
            newSubscriptionTemplateId: $route.current.params.newSubscriptionTemplateId
        });
    }

    function getProductchangeconfirmationData(sessionData, uiservice, $route) {
        return uiservice.productChangeConfirmationDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: $route.current.params.subscriptionTemplateId,
            uniqueSubscriptionId: $route.current.params.uniqueSubscriptionId
        });
    }

    function getOrderadministrationselectionData(sessionData, uiservice, $route) {
        return uiservice.orderAdministrationDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: $route.current.params.subscriptionTemplateId,
            uniqueSubscriptionId: $route.current.params.uniqueSubscriptionId});
    }

    function getOrderadministrationsummaryData(sessionData, uiservice, $route) {
        return uiservice.orderAdministrationSummaryDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: $route.current.params.subscriptionTemplateId,
            uniqueSubscriptionId: $route.current.params.uniqueSubscriptionId,
            requestedParameterValue: $route.current.params.requestedParameterValue
        });
    }

    function getOrderadministrationconfirmationData(sessionData, uiservice, $route) {
        return uiservice.orderAdministrationConfirmationDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: $route.current.params.subscriptionTemplateId,
            uniqueSubscriptionId: $route.current.params.uniqueSubscriptionId
        });
    }

    // it would be awkward to implement awaiting promises for session data, extracting response results as well as
    // handling errors for each dependency resolving function, so we do 'curry' it with the following resolver() function

    function resolver(dependencyFn) {
        return function (sessionData, uiservice, throwServiceResponseFault, $route) {
            return sessionData.promise.then(
                function () {
                    // CAUTH-312: if browser recovers after connection error, there
                    // is not a real error handling established, which may clear most
                    // recent error if user continues navigation. So we wipe it out here
                    sessionData.resetFault();

                    return dependencyFn.call(this, sessionData, uiservice, $route);
                }).then(
                function (resource) {
                    return resource.$promise.then(
                        function (result) {
                            return result.data;
                        }).catch(throwServiceResponseFault);
                });
        }
    }
}